<template>
  <div>
    <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form class="b-layout" @submit.prevent="">
      <div v-if="operationSelected">
        <div>
          <label>{{ $t('temperatura-do-vinho-bruto-oc') }} </label>
          <input v-model="Tr.value" min="0" step="0.1" type="number" />
        </div>
        <b-card class="mt-2">
          <div v-for="(dorna, index) in dornas" :key="dorna.equipName + index">
            <div class="inp mt-2" >
              <label>{{ $t('rendimento') }} {{ dorna.equipName }} (%): </label>
              <input
                v-model="dorna.value"
                min="0"
                step="0.5"
                @change="updateNode"
              />
            </div>
          </div>
        </b-card>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      attrList: ["Tr"],
      Tr: {},
      operations: [{ value: null, text:this.$t('selecione-uma-dorna-0') }],
      operationSelected: null,
      operationAttributeList: [],
      equipCap: [],
      dornas: [],
      firstLoad: false,
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
      this.updateNode();
    },

    "Tr.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.firstLoad = true;
      }

      this.dornas = new Array();
      
      this.node.data.forEach((p) => {
        if (p.caption == "Tr") {
          p.value = ParseToNumber(p.value);
          this.Tr = p;
        }
        
        if (p.equipName) {
          p.value = ParseToNumber(p.value);
          this.dornas.push(p);
        }
      });
      this.loadEquipments();
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Rendimento") {
            auxEquipment.push(props[p]);
          }
        });
      });
      this.dornas = auxEquipment;
    },

    updateNode() {
      let attrs = [this.Tr.clone()];
      this.dornas.forEach((e) => {
        let prop = e.clone();
        attrs.push(prop);
      });
      this.node.attrs = attrs;
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/RBC/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    setTimeout(this.loadNode(), 200);
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>